import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { EmployeesService } from '../../services/employees/employees.service';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';

import { SegmentEventName } from '@unico-people/shared/enums/utils-enums';

const documentStatusColor = {
  0: 'expired',
  1: 'pending',
  2: 'done',
  3: 'canceled',
}

@Component({
  selector: 'app-item-envelope-document',
  templateUrl: './item-envelope-document.component.html',
  styleUrls: ['./item-envelope-document.component.scss']
})

export class ItemEnvelopeDocumentComponent implements OnInit {
  static itemCounter = 0;
  @Input() item: any;
  @Input() employee: string;

  document: any;
  loading = false;
  loadingOpenDoc = false;  
  @Output() openDocumentData = new EventEmitter();

  itemId = 'item-id' + ItemEnvelopeDocumentComponent.itemCounter;
  isOpen = false;

  constructor(
    private employeesService: EmployeesService,
    private segment: TrackingSegmentService
  ) {
    ItemEnvelopeDocumentComponent.itemCounter++;
  }

  ngOnInit(): void {
    if (this.item) {
      this.item.status = documentStatusColor[this.item.id_envelopeStatus];
    }
  }

  downloadDocumet() {
    this.loading = true;
    this.trackinSegment(SegmentEventName.document_download);
    this.employeesService.downloadDocumentEmployee(this.employee, this.item.uuid)
    .subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = url;
      a.download = this.item.documentType;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.loading = false;
    });
  }

  openDocumet() {
    this.loadingOpenDoc = true;
    this.trackinSegment(SegmentEventName.document_opened);
    this.employeesService.downloadDocumentEmployee(this.employee, this.item.uuid)
    .subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.loadingOpenDoc = false;
    });
  }

  openDocumentDetails(): void {
    this.trackinSegment(SegmentEventName.document_details);
    this.openDocumentData.emit();
  }

  trackinSegment(eventTitle) {
    this.segment.track(eventTitle, { 
      status: this.item.envelopeStatus,
      category: this.item.documentCategoryName,
      location: 'Listagem'
    });
  }
}